import { Fragment } from "react";

// ---------------------------------------------------------------------------
// Section imports
// ---------------------------------------------------------------------------
import Header from "./Header.jsx";
import SwitchNav from "./SwitchNav.jsx";
import Overview from "./Overview.jsx";
import InternationalOutreach from "./InternationalOutreach.jsx";
import Events from "./Events.jsx";
import Tenders from "./Tenders.jsx";
import CountryDossiers from "./CountryDossiers.jsx";
import CountryCommercialReports from "./CountryCommercialReports.jsx";


// ---------------------------------------------------------------------------
// Single source of truth: drives the switch menu, the page order and the footer
// links. Add a section here and it appears everywhere automatically.
// ---------------------------------------------------------------------------
export const SECTIONS = [
  { id: "overview", label: "Overview", Component: Overview },
  { id: "outreach", label: "International Outreach", Component: InternationalOutreach },
  { id: "events", label: "Events", Component: Events },
  { id: "tenders", label: "Tenders", Component: Tenders },
  { id: "dossiers", label: "Country Dossiers", Component: CountryDossiers },
  { id: "reports", label: "Country Commercial Reports", Component: CountryCommercialReports },
];

// Nav/footer only need id + label
const NAV_ITEMS = SECTIONS.map(({ id, label }) => ({ id, label }));

// const Divider = () => (
//   <div className="h-px bg-gradient-to-r from-transparent via-[#FEF7F4] to-transparent" />
// );

export default function MainInternational() {
  return (
    <div className="min-h-screen bg-[#FAF7F2] font-['Outfit'] text-[#1a1a2e] antialiased selection:bg-[#DA2128] selection:text-white">
      {/* Hero */}
      <Header />

      {/* Sticky switch menu */}
      <SwitchNav sections={NAV_ITEMS} />

      {/* All sections */}
      <main className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-24 space-y-28">
        {SECTIONS.map(({ id, Component }, i) => (
          <Fragment key={id}>
            <Component />
            {/* {i < SECTIONS.length - 1 && <Divider />} */}
          </Fragment>
        ))}
      </main>

      {/* Footer */}
    </div>
  );
}
